import update from 'immutability-helper';
import _ from 'lodash';
import { makeActionCreator } from 'crazyEditor/redux/helpers';


const UPDATE_USER_DATA = 'user/UPDATE_USER_DATA';
const MARK_NOTIFICATIONS_AS_READ = 'user/MARK_NOTIFICATIONS_AS_READ';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case UPDATE_USER_DATA:
      return {
        ...state,
        ...action.userData,
      };
    case MARK_NOTIFICATIONS_AS_READ:
      const {notificationsIds} = action;
      const {notifications} = state;
      const updatedNotifications = {};
      _.forEach(notifications, (notification, key) => {
        if (_.includes(notificationsIds, notification.id)) {
          updatedNotifications[key] = {isRead: {$set: true}};
        }
      });
      return update(state, {
        notifications: updatedNotifications,
      });
    default:
      break;
  }
  return state;
}

export const updateUserData = makeActionCreator(UPDATE_USER_DATA, 'userData');
export const markNotificationsAsRead = makeActionCreator(MARK_NOTIFICATIONS_AS_READ, 'notificationsIds');
